<template>
  <section class="sec sec-8 mt-5 mb-5 sec-padding">
    <div class="sec-08-hex">
       <div class="model3">
         <span class="blue-light"></span>
         <span class="blue-light"></span>
       </div>
    </div>
    <div class="container-fluid">
       <div class="row justify-content-center sec8-sub1">
        <div class="col-lg-12 mt-5">
          <div class="sec-title ">
            <h1 class="wow fadeInUp has-u-line" data-wow-duration="1s" data-wow-delay=".1s" v-html="title"></h1>
          </div>
        </div>
        <div class="col-lg-5">
          <p>Are you up for a great collaboration? We at AlphaQ believe in joining hands with the right partners to provide excellent services.
             We invite potential partners to join us in our trading journey to offer the best in the market.</p>
          <div class="row justify-content-center mt-5">
            <div class="col-lg-3 col-sm-6">
              <div class="input-box">  <a class="neo-input" href="/becomepartner" type="submit">Get in Touch</a></div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="sec-title">
          <h1 class="has-u-line">WORKING WITH THE AlphaQ TEAM</h1>
        </div>
      </div>
      <div class="row justify-content-center sec8-sub2">
          <div class="col-lg-6">
              <p class="">
                  We count on brilliant heads who have the spirit to keep us at the vanguard of our industry.<br> 
                  <span class="spacer"></span>
                  Ours is a flat structure with an endless thirst for new ideas where different proposals are always welcomed and brought to prime concern, if practicable. Anyone joining hands with us can interrogate or put forward new ideas with the CEO or others within the firm. Every day there is something new to learn and a crisp challenge to prevailing over.<br> 
                  <span class="spacer"></span>
                  We aspire for the art of united power, where innovations are promoted and rewarded, and the importance of downtime is understood. In this rapidly evolving world, ours is an industry with ceaseless new waves. But if you stay motivated and are efficient enough to inspire others with your thirst for excellence, then we would definitely love to hear from you.
              </p>
          </div>
         
      </div>
    </div>
  </section>
</template>
<style  scopped>
.sec8-sub1 {
    background: url('/theme/img/workwith-bkg.png');
    background-size: 60%;
    padding-bottom: 12%;
    background-repeat: no-repeat;
    background-position: 27% 100%;
    position: relative;
    z-index: 1;
}
.sec8-sub1 p, .sec8-sub2 p{
     color: var(--title-color);
     font-size: var(--para-fontsize);
     line-height: 1.5;
     text-align: center;
}
.sec-08-hex{
  width: 100%;
    height: 100%;
    position: absolute;
    display: inline-block;
    z-index: 0;
    left: 0px;
    top: 0px;

}
.model3{
    width:26%;
    height: 100%;
    position: absolute;
    top: 18%;
    right: 0%;
}
.sec-08-hex .model3:before{
  content: '';
    background: url(/theme/img/sec2-hex3.svg);
    background-size: 120%;
    background-repeat: no-repeat;
    background-position: -218% 0%;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    opacity: 1;
}

.sec-08-hex .model3 .blue-light{
  left: unset;
}

.sec-08-hex .model3 .blue-light:nth-child(1){
    right: 4%;
    top: 18%;
}
.sec-08-hex .model3 .blue-light:nth-child(2){
    right: 24%;
    top: 42%;
}
@media (max-width: 480px) {
  .sec-08-hex{
        display: none;
    }
}
</style>
<script>
export default {
   props: {
    title: {
      type: String,
      default: ""
    },
    titleSub:{
      type: String,
      default: ""
    }
  }
  }
</script>